import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';

// Firebase configuration for atlas-41011
// These values are safe to expose in client-side code — Firebase Auth
// uses security rules and backend verification for protection, not API key secrecy.
const firebaseConfig = {
  apiKey: 'AIzaSyATzspBHTtiZQCfzXyJtbV4ZSzya6nHMoc',
  authDomain: 'atlas-41011.firebaseapp.com',
  projectId: 'atlas-41011',
  storageBucket: 'atlas-41011.firebasestorage.app',
  messagingSenderId: '342245088129',
  appId: '1:342245088129:web:fdcfdf6b3f15b9b827e680',
  measurementId: 'G-JYYLW29ZN1',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const localAuthEmulator = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;
if (import.meta.env.DEV && localAuthEmulator) {
  connectAuthEmulator(auth, `http://${localAuthEmulator}`, { disableWarnings: true });
}
